import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("urlAsaas");

const reqBillingAsaas = {
	insert: async function (body) {
		return apiServer
			.post("asaas/v1/billing", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	payWithCard: async function (body) {
		return apiServer
			.patch("asaas/v1/billing/paywithcard", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqBillingAsaas;
